import React from 'react';
import './components/conduct-discipline/Hero';
import Hero from './components/conduct-discipline/Hero';
import Main from './components/conduct-discipline/Main';

const ConductDiscipline = () => {
  return (
    <div>
        <Hero />
        <Main />
    </div>
  )
}

export default ConductDiscipline;